import { combineReducers } from "redux";
import countries from "./coutries";
import events from "./events";
import athelete from "./athelete";
import school from "./school";
import disclaimer from "./disclaimer";
const Reducers = () => combineReducers({ countries, events, athelete, school, disclaimer });

export default Reducers;
